export default function Team({ className, color }) {
  return (
    <svg
      id="équipe_classe"
      data-name="équipe / classe"
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      class={`MuiSvgIcon-root ${className}`}
      fill={color}
    >
      <g id="Groupe_2742" data-name="Groupe 2742">
        <rect
          id="Rectangle_3411"
          data-name="Rectangle 3411"
          width="30"
          height="30"
          fill="none"
        />
        <rect
          id="Rectangle_3412"
          data-name="Rectangle 3412"
          width="30"
          height="30"
          fill="none"
        />
      </g>
      <g
        id="Groupe_2749"
        data-name="Groupe 2749"
        transform="translate(0 7.468)"
      >
        <path
          id="Tracé_5967"
          data-name="Tracé 5967"
          d="M14.937,14.4a13.208,13.208,0,0,1,5.278,1.12,3.715,3.715,0,0,1,2.191,3.4v2.016H7.468v-2a3.689,3.689,0,0,1,2.191-3.4A13,13,0,0,1,14.937,14.4Zm-9.958.311a2.489,2.489,0,1,0-2.489-2.489A2.5,2.5,0,0,0,4.979,14.713Zm1.407,1.369a8.692,8.692,0,0,0-1.407-.124,8.652,8.652,0,0,0-3.46.722A2.5,2.5,0,0,0,0,18.983v1.954H5.6v-2A5.6,5.6,0,0,1,6.386,16.082Zm18.509-1.369a2.489,2.489,0,1,0-2.49-2.489A2.5,2.5,0,0,0,24.895,14.713Zm4.979,4.269a2.5,2.5,0,0,0-1.519-2.3,8.462,8.462,0,0,0-4.867-.6,5.6,5.6,0,0,1,.784,2.85v2h5.6ZM14.937,6A3.734,3.734,0,1,1,11.2,9.734,3.729,3.729,0,0,1,14.937,6Z"
          transform="translate(0 -6)"
          fill={color}
        />
      </g>
    </svg>
  );
}
